import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 3H4.5C3.67158 3 3 3.67158 3 4.5V19.5C3 20.3285 3.67158 21 4.5 21H19.5C20.3285 21 21 20.3285 21 19.5V4.5C21 3.67158 20.3285 3 19.5 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00098 11.501C10.3817 11.501 11.501 10.3817 11.501 9.00098C11.501 7.62028 10.3817 6.50098 9.00098 6.50098C7.62028 6.50098 6.50098 7.62028 6.50098 9.00098C6.50098 10.3817 7.62028 11.501 9.00098 11.501Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.896 13.1095C14.3042 12.5632 15.1274 12.5767 15.5174 13.136L19.9048 19.4278C20.3671 20.0908 19.8927 20.9998 19.0845 20.9998H8.00098L13.896 13.1095Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
